import React from 'react'
import ProjectCarouselButtons from '../ProjectCarouselButtons'

const FirebaseLogin = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsFirebaseLogin" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <video controls="controls" className="d-block w-100">
                                    <source src="../IMG/FirebaseLogin/FirebaseLogin.mp4" type="video/mp4" />
                                </video>
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/FirebaseLogin/FirebaseLogin.jpeg" className="d-block w-100" alt="..." />
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="FirebaseLogin" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">FirebaseLogin</p>
                            <p className="Project--info--subheading">FullStack Web Development</p>
                            <p className="Project--info--subheading">Using MERN Stack & Firebase</p>
                            <p className="Project--info--Para">The Firebase Login Interface streamlines authentication, allowing users to log in via Google, GitHub, and Facebook. It enhances security with OTP (One-Time Password) verification, ensuring a secure and versatile login experience.</p>
                            <p className="Project--info--Para">The Firebase Login Interface provides secure login options with Google, GitHub, and Facebook, along with OTP verification on websites. This ensures user flexibility and an added layer of security.</p>
                        </div>
                        <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/Firebase-Login" target='__blank'>Github</a>
                        </div>
                        <div className="Project--info--tech">
                            <p>Firebase</p>
                            <p>Meta Dev</p>
                            <p>React.js</p>
                            <p>Html/Css </p>
                            <p>Javascript</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FirebaseLogin